import React, { useState, Component } from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';


toast.configure()
const TextComponent = (props) => {
    const [scriptdata, setScriptData] = React.useState(props.text);
    const [isUpdatingScript, setIsUpdatingScript] = React.useState(false)

    const copyContent = async () => {
        let text = document.getElementById('myText').innerHTML;
        try {
            let cleanText = text.replace(/<\/?[^>]+(>|$)/g, "");

            await navigator.clipboard.writeText(cleanText);
            console.log('Content copied to clipboard');
            toast.info('Content copied to clipboard')
        } catch (err) {
            console.error('Failed to copy: ', err);
        }
    };
    function handleScriptChange(event) {
        //setScriptData(event.target.value); // invert value
        console.log('Content copied to clipboard', event.target.value);
        // setIsUpdatingScript(true)
        props.onScriptChange(event.target.value);

    }

    //let data = props.text.split('\n').map((item, i) =><p key={i}>{item}</p>).join('');
    //let text = data.toString();
    console.log('props.text=', props);

    // function handleConvertToVoice (){

    //     this.props.history.push("/speech/generate/5d88bda562c33a2da8d38619?"+`id=${this.props.script._id}`);
    //     // return (
    //     //     <Redirect to={`/speech/generate/5d88bda562c33a2da8d38619?id=${this.props.script._id}`}/>
    //     // )
    // }

    return <div className="generate-data">
        {/* <textarea id="myText" value={props.text} onChange={props.onScriptChange} style={{ "width": "100%" }} /> */}
        <textarea id="myText" value={props.text} onChange={handleScriptChange} style={{ "width": "100%" }} />
        <br />
        <div style={{display: 'flex', gap: '12px'}}>
            <button className="btn btn-primary " onClick={copyContent}>Copy Script</button>
            {/* { isUpdatingScript ?
                    <>
                        <button className="btn btn-primary" onClick={props.handleConvertToVoice}>Update Script</button>
                        <button className="btn btn-primary" onClick={props.handleProjectSelect}>Cancel</button>
                    </>
                :
                    <>
                    </>
            } */}
            {
                props.isScriptSavedInDb ?
                    <button className="btn btn-primary" onClick={props.handleUpdateScript}>Update Script</button>
                :
                    <>
                        {
                            !props.isScriptSaved && <button className="btn btn-primary" onClick={props.handleSaveScript}>Save Script</button>
                        }
                    </>
            }
            {/* <button className="btn btn-primary" onClick={props.handleConvertToVoice}>Add to project</button> */}
            { props.isScriptSaved && (
                    <>
                        <button className="btn btn-primary" onClick={props.handleConvertToVoice}>Edit for Voice</button>
                        <button className="btn btn-primary" onClick={props.handleProjectSelect}>Add to project</button>
                    </>
                ) 
            }
        </div>
        
    </div>
}

export default TextComponent;